<div class="buyBaner container p-3">
    <h1>Buy banner !</h1>
    <baner-token-payment (onTokenAdded)="onTokenAdded($event)"></baner-token-payment>
</div>
